import { Component, OnInit } from "@angular/core";
import { SuperAdminService } from "src/app/super-admin.service";
import { ActivatedRoute, Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-monthly-expense",
  templateUrl: "./monthly-expense.component.html",
  styleUrls: ["./monthly-expense.component.css"],
})
export class MonthlyExpenseComponent implements OnInit {
  expenseArr: any = [];
  expenseArray: any = [];
  myArr: any = [];
  paramId: any;
  month: any;
  userSessionData: any = JSON.parse(sessionStorage.getItem("userSession"));
  monthArr: any = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "June",
    "July",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  monthArrFull: any = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  year: any;
  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private toastr: ToastrService,
    private superadminService: SuperAdminService
  ) {
    this.activatedRoute.params.subscribe((param) => {
      this.month = +param.id;
      this.year = +param.year;
    });
  }

  ngOnInit(): void {
    this.getExpenseByMonthAndYear();
  }

  get monthName(): string {
    return this.monthArrFull[this.month - 1] || "";
  }

  getExpenseByMonthAndYear() {
    this.superadminService
      .monthlyGeneralCashExpenseByMonthAndYear(this.year, this.month)
      .subscribe(
        (res) => {
          if (res.status) {
            this.expenseArray = res.data;
          } else {
            this.toastr.error(res.message);
          }
        },
        (error) => {
          this.toastr.error("Something went wrong");
        }
      );
  }

  backTo() {
    window.history.back();
  }
}
